export default "__VITE_ASSET__NQX8cy41__"